import React, { useEffect, useState } from 'react'
import { showToast } from '../../Common/Messages';

const DocList = (props) => {
    const [tree, setTree] = useState([]);

    useEffect(() => {
        if (props.data !== null)
            setTree(props.data);
    }, [props]);

    const onClickNode = node => {
        props.onClickNode(node);
    }
    const addSubClick = (e, node) => {
        e.stopPropagation();
        props.addSubClick(node);
    }
    const addDocument = node => {
        if (!node.item.module || node.item.module === "") {
            showToast('warning', "문서제목을 입력해주세요.", 3000);
            return;
        }
        props.addDocument(node);
    };
    const removeNode = () => {
        props.removeNode();
    }

    const [draggedNode, setDraggedNode] = useState(null);
    const [dragOverNodeId, setDragOverNodeId] = useState(null);
    const [dropAction, setDropAction] = useState({});

    // 자기 자신 또는 children으로 드래그 방지
    const isDescendant = (parent, child) => {
        const parentNode = parent.item ?? parent;
        if (parentNode.docId === child.item.docId) return true;
        else if (!parentNode.children) return false;
        for (const node of parentNode.children) {
            if (node.docId === child.item.docId || isDescendant(node, child)) {
                return true;
            }
        }
        return false;
    };

    const onDragStart = (e, node) => {
        e.stopPropagation();
        setDraggedNode(node);
    };

    const onDrop = (e, targetNode) => {
        e.preventDefault();
        e.stopPropagation();

        if (!draggedNode || draggedNode.item.docId === targetNode.item.docId) return;

        // 자기 자신의 child로 드래그 방지
        if (isDescendant(draggedNode, targetNode)) {
            setDropAction({});
            return;
        }

        props.updateDocList(draggedNode, targetNode, dropAction);

        setDraggedNode(null);
        setDragOverNodeId(null);
        setDropAction({});
    };

    const onDragOver = (e, targetNode) => {
        e.preventDefault();
        e.stopPropagation();

        // 자기 자신의 child로 드래그 방지
        if (draggedNode && isDescendant(draggedNode, targetNode)) {
            setDropAction({});
            return;
        }

        const rect = e.target.getBoundingClientRect();
        const offsetY = e.clientY - rect.top;
        const height = rect.height;

        if (offsetY < height * 0.25) {
            // 위 가장자리: move 위
            setDropAction({ above: true, below: false, child: false });
        } else if (offsetY > height * 0.75) {
            // 아래 가장자리: move 아래
            setDropAction({ above: false, below: true, child: false });
        } else {
            // 중앙: child 포함
            setDropAction({ above: false, below: false, child: true });
        }

        setDragOverNodeId(targetNode.item.docId);
    };
    return (
        <div className="ctgr-tree">
            <SubTreeContainer
                data={tree}
                activeNode={props.current ?? ''}
                depth={-1}
                treeView={true}
                nodepath={''}
                isSearch={props.isSearch}
                isEditable={props.isEditable}
                keyword={props.keyword}
                onClickNode={onClickNode}
                addSubClick={addSubClick}
                addDocument={addDocument}
                removeNode={removeNode}
                isViewMode={props.isViewMode}
                onDragStart={onDragStart}
                onDrop={onDrop}
                onDragOver={onDragOver}
                dragOverNodeId={dragOverNodeId}
                dropAction={dropAction}
            />
        </div>
    );
}
const SubTreeContainer = (props) => {
    const onClickNode = node => {
        props.onClickNode(node);
    };
    const addSubClick = (e, node) => {
        props.addSubClick(e, node);
    };
    const addDocument = node => {
        props.addDocument(node);
    };
    const removeNode = () => {
        props.removeNode();
    }
    const items = props.data;
    let style = {
        display: props.treeView ? "block" : "none",
        animation: "scale - display--reversed .3s"
    };
    let treeItems = [];
    let index = 0;
    let path = props.path !== undefined ? props.path : "";
    let numPath = props.numPath !== undefined ? props.numPath + '_' : "";
    let depth = props.depth + 1;
    let nodepath = props.nodepath;

    for (let i = 0; i < items.length; i++) {
        if (items[i].hasOwnProperty("children")) {
            let isCollapsed = true, isHasItem = false, itemArr = new Array();
            var isactive = false;
            if (items[i].docId && items[i].docId === props.activeNode.item?.docId) {
                isactive = true;
            }
            if (items[i].collapsed === undefined || items[i].collapsed === null) {
                isCollapsed = false;
            } else {
                isCollapsed = items[i].collapsed;
            }
            if (nodepath !== '' && nodepath !== undefined) {
                itemArr.push(items[i]);
                isHasItem = isHasItem(itemArr, nodepath);
                if (isHasItem) {
                    nodepath = nodepath.substring(nodepath.indexOf('/') + 1)
                    isCollapsed = false;
                }
            }
            treeItems.push(
                <SubTree
                    index={index++}
                    item={items[i]}
                    data={items[i].children}
                    depth={depth}
                    path={path}
                    collapsed={isCollapsed}
                    name={items[i].module}
                    numPath={numPath + i.toString()}
                    activeNode={props.activeNode}
                    nodepath={nodepath}
                    isSearch={props.isSearch}
                    isEditable={props.isEditable}
                    keyword={props.keyword}
                    onClickNode={onClickNode}
                    addSubClick={addSubClick}
                    addDocument={addDocument}
                    removeNode={removeNode}
                    isViewMode={props.isViewMode}
                    onDragStart={props.onDragStart}
                    onDrop={props.onDrop}
                    onDragOver={props.onDragOver}
                    dragOverNodeId={props.dragOverNodeId}
                    dropAction={props.dropAction}
                />
            )
        } else {
            var isactive = false;
            if (items[i].docId === props.activeNode.item?.docId) {
                isactive = true;
            }
            treeItems.push(
                <Node
                    key={index++}
                    item={items[i]}
                    depth={depth}
                    path={path}
                    name={items[i].module}
                    numPath={numPath + i.toString()}
                    activate={isactive}
                    isSearch={props.isSearch}
                    isEditable={props.isEditable}
                    keyword={props.keyword}
                    onClickNode={onClickNode}
                    addSubClick={addSubClick}
                    addDocument={addDocument}
                    removeNode={removeNode}
                    isViewMode={props.isViewMode}
                    onDragStart={props.onDragStart}
                    onDrop={props.onDrop}
                    onDragOver={props.onDragOver}
                    dragOverNodeId={props.dragOverNodeId}
                    dropAction={props.dropAction}
                />
            );
        }
    }

    if (props.depth < 0)
        return treeItems;
    return (
        <ul className={props.depth === 0 ? "tree" : ""} style={style}>
            {treeItems}
        </ul>
    );
};
const SubTree = (props) => {
    const [state, setState] = useState({
        expandClass: props.collapsed ? "btn-expand collapse" : "btn-expand",
        collapsed: props.collapsed
    });
    const onClickNode = node => {
        props.onClickNode(node);
    };

    const changeCollapse = (e) => {
        if (state.collapsed) {
            setState({ expandClass: "btn-expand", collapsed: false });
        } else {
            setState({ expandClass: "btn-expand collapse", collapsed: true });
        }
    };

    const addSubClick = (e, node) => {
        props.addSubClick(e, node);
    };

    const addDocument = node => {
        props.addDocument(node);
    };
    const removeNode = () => {
        props.removeNode();
    }

    const { item, numPath } = props;
    const prePath = (props.path ? props.path + '/' : '') + props.name;
    let path = prePath !== props.name + '/' ? prePath : "";
    var isactive = false;
    if (item.docId && item.docId === props.activeNode.item?.docId) {
        isactive = true;
    }
    if (props.depth === 0) {
        return (
            <SubTreeContainer
                index={props.index + 1}
                data={props.data}
                depth={props.depth}
                item={props.item}
                path={path}
                treeView={state.collapsed ? false : true}
                numPath={props.numPath}
                activeNode={props.activeNode}
                nodepath={props.nodepath}
                isSearch={props.isSearch}
                isEditable={props.isEditable}
                keyword={props.keyword}
                onClickNode={onClickNode}
                addSubClick={addSubClick}
                addDocument={addDocument}
                removeNode={removeNode}
                isViewMode={props.isViewMode}
                onDragStart={props.onDragStart}
                onDrop={props.onDrop}
                onDragOver={props.onDragOver}
                dragOverNodeId={props.dragOverNodeId}
                dropAction={props.dropAction}
            />
        )
    }
    else
        return (
            <li
                draggable={props.isEditable}
                onDragStart={(e) => props.onDragStart(e, props)}
                onDrop={(e) => props.onDrop(e, props)}
                onDragOver={(e) => props.onDragOver(e, props)}
                style={{
                    borderTop: props.dragOverNodeId === props.item.docId && props.dropAction.above ? "2px solid #007bff" : "none",
                    borderBottom: props.dragOverNodeId === props.item.docId && props.dropAction.below ? "2px solid #007bff" : "none",
                    backgroundColor: props.dragOverNodeId === props.item.docId && props.dropAction.child ? "#d1e7ff" : "transparent",
                }}
            >
                <Node
                    item={item}
                    depth={props.depth}
                    path={props.path}
                    numPath={numPath}
                    name={props.name}
                    activate={isactive}
                    isSearch={props.isSearch}
                    isEditable={props.isEditable}
                    keyword={props.keyword}
                    onClickNode={onClickNode}
                    addSubClick={addSubClick}
                    addDocument={addDocument}
                    removeNode={removeNode}
                    expandClass={state.expandClass}
                    changeCollapse={changeCollapse}
                    isViewMode={props.isViewMode}
                    onDragStart={props.onDragStart}
                    onDrop={props.onDrop}
                    onDragOver={props.onDragOver}
                    dragOverNodeId={props.dragOverNodeId}
                    dropAction={props.dropAction}
                />
                <SubTreeContainer
                    index={props.index + 1}
                    data={props.data}
                    depth={props.depth}
                    item={props.item}
                    path={path}
                    treeView={state.collapsed ? false : true}
                    numPath={props.numPath}
                    activeNode={props.activeNode}
                    nodepath={props.nodepath}
                    isSearch={props.isSearch}
                    isEditable={props.isEditable}
                    keyword={props.keyword}
                    onClickNode={onClickNode}
                    addSubClick={addSubClick}
                    addDocument={addDocument}
                    removeNode={removeNode}
                    isViewMode={props.isViewMode}
                    onDragStart={props.onDragStart}
                    onDrop={props.onDrop}
                    onDragOver={props.onDragOver}
                    dragOverNodeId={props.dragOverNodeId}
                    dropAction={props.dropAction}
                />
            </li>
        );
}
const Node = (props) => {
    const li = React.createRef();

    const nodeClick = (e, node) => {
        e.preventDefault();
        props.onClickNode(node);
    };

    const changeCollapse = (e, node) => {
        e.preventDefault();
        e.stopPropagation();
        props.changeCollapse(e);
    };

    const addSubClick = (e, node) => {
        e.preventDefault();
        e.stopPropagation();
        props.addSubClick(e, node);
    };
    const addDocument = (e, node) => {
        e.preventDefault();
        node.item.module = docBoxName;
        props.addDocument(node);
    }
    const removeNode = () => {
        props.removeNode();
    }
    const checkDocBox = (e, node) => {
        // focus out시, 문서 이름이 비어있으면 노드삭제
        if (docBoxName === "") {
            removeNode();
        } else {
            e.preventDefault();
            e.stopPropagation();
            showToast('warning', "문서 생성을 완료해주세요.");
            return;
        }
    }

    const highlightMatch = (text, query) => {
        if (!query || !props.isSearch) return text;
    
        const regex = new RegExp(`(${query})`, 'gi');
        const parts = text.split(regex);
    
        return parts.map((part, i) =>
            regex.test(part) ? <mark key={i}>{part}</mark> : part
        );
    };

    const [docBoxName, setDocBoxName] = useState('');
    let activateClass = props.activate ? ' on' : '';
    if (props.name === '' && props.item.docId === 'add') {
        return (
            <li ref={li}>
                <a
                    className={"depth-" + (props.depth > 1 ? props.depth + " last-depth" : props.depth) + activateClass}
                    href={() => { }}>
                    <i className="icoKdc20 document"></i>
                    <input type="text" className="txt file" placeholder='문서제목을 정해주세요' value={docBoxName}
                        onKeyDown={e => { if (!e.nativeEvent.isComposing && e.key === 'Enter') addDocument(e, props); }} onChange={e => setDocBoxName(e.target.value)}
                        onBlur={(e) => checkDocBox(e, props)} autoFocus
                    />
                    <div className="icoKdc20 add btn-add-folder" title="추가" onMouseDown={e => addDocument(e, props)}><i className="i-manual-add-folder"></i></div>
                </a>
            </li>
        );
    }
    if (props.item.children !== undefined)
        return (
            <a className={"depth-" + props.depth + activateClass} onClick={e => nodeClick(e, props)} href={() => { }}>
                <div className={props.expandClass} onClick={e => changeCollapse(e, props)}>
                    <i className="icoKdc16 expand"></i>
                </div>
                <i className="icoKdc20 document icon-folder"></i>
                <span className="txt folder">{highlightMatch(props.name, props.keyword)}</span>
                {props.isEditable &&
                    <div className="icoKdc20 add btn-add-folder" title="하위추가" onClick={e => addSubClick(e, props)}><i className="i-manual-add-folder"></i></div>
                }
            </a>
        );
    else
        return (
            <li ref={li}
                draggable={props.isEditable}
                onDragStart={(e) => props.onDragStart(e, props)}
                onDrop={(e) => props.onDrop(e, props)}
                onDragOver={(e) => props.onDragOver(e, props)}
                style={{
                    borderTop: props.dragOverNodeId === props.item.docId && props.dropAction.above ? "2px solid #007bff" : "none",
                    borderBottom: props.dragOverNodeId === props.item.docId && props.dropAction.below ? "2px solid #007bff" : "none",
                    backgroundColor: props.dragOverNodeId === props.item.docId && props.dropAction.child ? "#d1e7ff" : "transparent",
                }}
            >
                <a
                    className={"depth-" + props.depth + activateClass + " last-depth "}
                    href={() => { }}
                    onClick={e => nodeClick(e, props)}>
                    <i className="icoKdc20 document icon-folder"></i>
                    <span className="txt file">{highlightMatch(props.name, props.keyword)}</span>
                    {props.isEditable &&
                        <div className="icoKdc20 add btn-add-folder" title="하위추가" onClick={e => addSubClick(e, props)}><i className="i-manual-add-folder"></i></div>
                    }
                </a>
            </li>
        );
}
export default DocList;